import { TextField, NumberInput } from "react-admin";
import { MyList } from "../../ra-lb-tools/components/myList";
import { MyCreate as Create } from "../../ra-lb-tools/components/myMutator";
import { AddShoppingCartOutlined } from "@mui/icons-material";
import { TowerModelField, TowerModelInput } from "../tower_model/TowerModel";
import { CurrencyCentsField } from "../../ra-lb-tools/components/currencyField";
export const MinMaxGeneratorIcon = AddShoppingCartOutlined;

export const MinMaxGeneratorList = (props) => (
  <MyList {...props} resource="min-max-generators">
    <TextField source="id" />
    <TowerModelField source="towerModel.id" label="Tower Model" />
    <CurrencyCentsField source="firstTier" />
    <CurrencyCentsField source="secondTier" />
  </MyList>
);

export const MinMaxGeneratorCreate = (props) => {
  return (
    <Create
      {...props}
      columns={1}
      transform={(data) => ({
        ...data,
        firstTier: data.firstTier * 100,
        secondTier: data.secondTier * 100,
      })}
    >
      <TowerModelInput source="towerModelId" />
      <NumberInput source="firstTier" />
      <NumberInput source="secondTier" />
    </Create>
  );
};
